var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var RemoteFile = require('./remote-file');

var RemoteLink = require('./remote-link');

var RemoteBoard =
/*#__PURE__*/
function () {
  "use strict";

  function RemoteBoard(values) {
    _classCallCheck(this, RemoteBoard);

    Object.assign(this, values);
    this.normalizeItems();
  }

  _createClass(RemoteBoard, [{
    key: "normalizeItems",
    value: function normalizeItems() {
      this.items = this.items.map(function (item) {
        switch (item.type) {
          case 'link':
            return new RemoteLink(item);

          case 'file':
            return new RemoteFile(item);
        }
      });
    }
  }, {
    key: "addLinks",
    value: function addLinks() {
      var _this = this,
          _this$items;

      for (var _len = arguments.length, links = new Array(_len), _key = 0; _key < _len; _key++) {
        links[_key] = arguments[_key];
      }

      var remoteLinks = links.map(function (link) {
        var remoteLink = new RemoteLink(link);
        remoteLink.board = _this;
        return remoteLink;
      });

      (_this$items = this.items).push.apply(_this$items, _toConsumableArray(remoteLinks));
    }
  }, {
    key: "addFiles",
    value: function addFiles() {
      var _this2 = this,
          _this$items2;

      for (var _len2 = arguments.length, files = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        files[_key2] = arguments[_key2];
      }

      var remoteFiles = files.map(function (file) {
        var remoteFile = new RemoteFile(file);
        remoteFile.board = _this2;
        return remoteFile;
      });

      (_this$items2 = this.items).push.apply(_this$items2, _toConsumableArray(remoteFiles));
    }
  }, {
    key: "links",
    get: function get() {
      return this.items.filter(function (item) {
        return item.type === 'link';
      });
    }
  }, {
    key: "files",
    get: function get() {
      return this.items.filter(function (item) {
        return item.type === 'file';
      });
    }
  }]);

  return RemoteBoard;
}();

module.exports = RemoteBoard;